module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f95ab98a0575873b73d358149fa4245a.png";